import { AxiosPromise } from 'axios';
import { AxiosClientFactory } from '../../../common/helpers/AxiosClientFactory';
import { ConsumerLoanBrief } from '../models/ConsumerLoanBrief';

export const getConsumerLoans = (personId: number | string): AxiosPromise<ConsumerLoanBrief[]> => {
    return AxiosClientFactory
        .getInstance()
        .get<ConsumerLoanBrief[]>(`/api/applicants/${personId}/consumerLoans`);
};
